var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScaleUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,6.7l1.9-2L9.4,4.1c-0.2-0.2-0.2-0.5,0-0.7c0.1-0.1,0.2-0.1,0.3-0.1H12c0.3,0,0.5,0.2,0.5,0.5c0,0,0,0,0,0 v2.4c0,0.3-0.2,0.5-0.4,0.5c-0.2,0-0.3,0-0.4-0.2L11,5.8l-1.9,2c-0.1,0.1-0.3,0.1-0.4,0c0,0,0,0,0,0L8.2,7.2 C8.1,7.1,8.1,6.9,8.2,6.7C8.2,6.7,8.2,6.7,8.2,6.7z M7.8,9.3l-1.9,2l0.7,0.7c0.2,0.2,0.2,0.5,0,0.7c-0.1,0.1-0.2,0.1-0.3,0.1H4 c-0.3,0-0.5-0.2-0.5-0.5c0,0,0,0,0,0V9.9c0-0.3,0.2-0.5,0.4-0.5c0.2,0,0.3,0,0.4,0.2L5,10.2l1.9-2c0.1-0.1,0.3-0.1,0.4,0 c0,0,0,0,0,0l0.5,0.6C7.9,8.9,7.9,9.1,7.8,9.3C7.8,9.3,7.8,9.3,7.8,9.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleUp);
export default __webpack_public_path__ + "static/media/scale-up.ac84499d79de224d10cfc60561a7a1c0.svg";
export { ForwardRef as ReactComponent };